import React, { useState, useCallback } from 'react';
import { ReactComponent as PCSvg } from '../../assets/images/home/SVG/pc-svg.svg';
import { ReactComponent as GSvg } from '../../assets/images/home/SVG/g-svg.svg';
import cactusHero from '../../assets/images/home/cactus-hero.png';
import Circle from './Circle';
import './Hero.css';

const Hero = () => {
    const COLORS = ['#d1db4a', '#003d2d', '#00b3b9', '#517013', '#56c648', '#f9efd9'];
    const INITIAL_CIRCLES = 55;
    const MIN_CIRCLES = 3;
    const MAX_CIRCLES = 5;
    const HOVER_RADIUS = 200;
    const MAX_SCALE = 0.7; 

    const [circles, setCircles] = useState(() => {
        // Generate initial hexagons with rotation
        return Array.from({ length: INITIAL_CIRCLES }, () => ({
            x: Math.random() * window.innerWidth,
            y: Math.random() * window.innerHeight,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
            radius: 35 + Math.random() * 25, // Increased base size: 35-60px
            rotation: Math.random() * 360,
            id: Math.random()
        }));
    });

    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

    const handleMouseMove = useCallback((e) => {
        setMousePos({ x: e.clientX, y: e.clientY });
    }, []);

    const handleClick = useCallback((e) => {
        const numNewCircles = MIN_CIRCLES + Math.floor(Math.random() * (MAX_CIRCLES - MIN_CIRCLES + 1));
        const scatterRadius = 100;

        const newCircles = Array.from({ length: numNewCircles }, () => {
            const angle = Math.random() * Math.PI * 2;
            const distance = Math.random() * scatterRadius;
            return {
                x: e.clientX + Math.cos(angle) * distance,
                y: e.clientY + Math.sin(angle) * distance,
                color: COLORS[Math.floor(Math.random() * COLORS.length)],
                radius: 35 + Math.random() * 25, // Matching initial size range
                rotation: Math.random() * 360,
                id: Math.random()
            };
        });

        setCircles(prev => [...prev, ...newCircles]);
    }, []);

    return (
        <div className="hero-container" onMouseMove={handleMouseMove} onClick={handleClick}>
            <div className="circles-container">
                {circles.map(circle => (
                    <Circle
                        key={circle.id}
                        x={circle.x}
                        y={circle.y}
                        color={circle.color}
                        initialRadius={circle.radius}
                        mousePos={mousePos}
                        hoverRadius={HOVER_RADIUS}
                        maxScale={MAX_SCALE}
                    />
                ))}
            </div>
            <div className="hero-content">
                <img src={cactusHero} alt="Cactus Hero" className="cactus-hero" />
                <div className="logo-container">
                    <PCSvg className="pc-svg" />
                    <GSvg className="g-svg" />
                </div>
            </div>
        </div>
    );
};

export default Hero;
